module.exports = __webpack_public_path__ + "media/warranty-claim/affected-success-92e19c16.svg";